let centerMark = [60.049145, 34.624261];
function init() {
  let map = new ymaps.Map('map', {
    center: centerMark,
    zoom: 13
  });

  let placemark = new ymaps.Placemark(centerMark, {}, {
    iconLayout: 'default#image',
    iconImageHref: 'img/sprite.svg#leaf',
    iconImageSize: [200, 200],
    iconImageOffset: [-60, -125]
  });

  map.controls.remove('geolocationControl'); // удаляем геолокацию
  map.controls.remove('searchControl'); // удаляем поиск
  map.controls.remove('trafficControl'); // удаляем контроль трафика
  map.controls.remove('typeSelector'); // удаляем тип
  map.controls.remove('fullscreenControl'); // удаляем кнопку перехода в полноэкранный режим
  map.controls.remove('zoomControl'); // удаляем контрол зуммирования
  map.controls.remove('rulerControl'); // удаляем контрол правил
  map.behaviors.disable(['scrollZoom']); // отключаем скролл карты (опционально)

  map.geoObjects.add(placemark)
}

ymaps.ready(init);
